import { TITAN_EVENTS } from '../titan';

export const EVENTS = {
  CLICK: 'click',
  PAGE_LOAD: 'page_load',
  SIDEBAR_LOAD: 'sidebar_load',
  COMPONENT_LOAD: 'component_load',
  ERROR: 'error',
  SUCCESS: 'success',
  DEBUG: 'debug',
  VIEW: 'view',
};

export const EVENT_VALUES = {
  [EVENTS.VIEW]: {
    app_store_cta: 'app_store_cta',
  },
  [EVENTS.CLICK]: {
    product_recommendations: 'product_recommendations',
    location_tile: 'location_tile',
    location_sort_by: 'location_sort_by',
    location_show_more: 'location_show_more',
    location_show_less: 'location_show_less',
    preferences_create_profile: 'preferences_create_profile',
    preferences_complete_profile: 'preferences_complete_profile',
    preferences_manage_profile: 'preferences_manage_profile',
    preferences_update_profile: 'preferences_update_profile',
    preferences_checkbox: 'preferences_checkbox',
    confirmation_page_cta_button: 'confirmation_page_cta_button',
    confirmation_page_loop_link: 'confirmation_page_loop_link',
    store_associate_override_button: 'store_associate_override_button',
    action_type_selection_exchange: 'action_type_selection_exchange',
    action_type_selection_return: 'action_type_selection_return',
    action_type_selection_claim: 'action_type_selection_claim',
    reason: 'reason',
    app_store_cta_apple: 'app_store_cta_apple',
    app_store_cta_google: 'app_store_cta_google',
  },
  [EVENTS.PAGE_LOAD]: {
    'step-1': 'item_selection',
    'step-2': 'method',
    'step-3': 'review',
    'step-4': 'confirmation',
    'faq/local_pickup': 'faq/local_pickup',
    default: 'login_default',
  },
  [EVENTS.SIDEBAR_LOAD]: {
    return_reasons: 'return_reasons',
    address_validation: 'address_sidebar',
    scheduled_pickup: 'scheduled_pickup',
    repair_reasons: 'repair_reasons',
    blind_return_reasons: 'blind_return_reasons',
    blind_repair_reasons: 'blind_repair_reasons',
  },
  [EVENTS.COMPONENT_LOAD]: {
    store_locations_sort: 'store_locations_sort',
    preferences_email_input: 'preferences_email_input',
  },
  [EVENTS.ERROR]: {
    order_validation: 'order_validation',
    return_methods: 'return_methods',
    return_submit: 'return_submit',
    inventory: 'inventory',
    preferences_save: 'preferences_save',
  },
  [EVENTS.SUCCESS]: {
    preferences_save: 'preferences_save',
  },
  [EVENTS.DEBUG]: {
    preferences_eligibility_false: 'preferences_eligibility_false',
    refund_option_missing: 'refund_option_missing',
  },
};

export const EVENT_TYPE_NOFLAKE_TO_TITAN = {
  [EVENTS.PAGE_LOAD]: TITAN_EVENTS.CHECKOUT_STEP_VIEWED,
};

export const EVENT_VALUE_NOFLAKE_TO_TITAN = {
  [EVENTS.PAGE_LOAD]: {
    item_selection: { step: 1 },
    method: { step: 2 },
    review: { step: 3 },
    confirmation: { step: 4 },
  },
};
